import { useEffect, useState } from 'react';

export default function useInventoryUrlWithFilters(to: string) {
  const [urlWithFilters, setUrlWithFilters] = useState<string>(to.toString());

  // Note: useEffect will guarantee this code is run on the client side where sessionStorage is available. useMemo doesn't work because
  // Remix will run useMemo on the server once to hydrate the memoized value in the SSR'd HTML that gets send to the client.
  useEffect(() => {
    const inventoryFilters = sessionStorage.getItem('inventoryFilters');

    // Regex tests specifically for /inventory/{marketId} paths where the URL ends after {marketId}
    const isMarketSpecificInventoryPage = new RegExp(/^\/inventory\/[^/]+$/).test(
      to.toString()
    );

    // Inventory filters are only included on inventory URLs (i.e. market-specific inventory URL or /inventory)
    setUrlWithFilters(
      (isMarketSpecificInventoryPage || to.toString() === '/inventory') &&
        inventoryFilters
        ? to.toString() + `?${inventoryFilters}`
        : to.toString()
    );
  }, [to]);

  return urlWithFilters;
}
